import { render, staticRenderFns } from "./Distro.vue?vue&type=template&id=475fccc3&scoped=true"
import script from "./Distro.vue?vue&type=script&lang=js"
export * from "./Distro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475fccc3",
  null
  
)

export default component.exports